<app-date-controls (dateChange)="onChangedDate($event)"></app-date-controls>
<app-image-columns [data]="data" [column]="2" [restPolicy]="'full'"></app-image-columns>